const base = "cui-headline-sagu";
const l = "cui-headline-l-tzwg";
const m = "cui-headline-m-zzat";
const s = "cui-headline-s-nb07";
const classes = {
  base,
  l,
  m,
  s
};
export {
  base,
  classes as default,
  l,
  m,
  s
};
